import { useMemo, useRef } from "react";
import {
  createPreparedBranchAPI,
  removePreparedBranchAPI,
  removePreparedBranchLicenseAPI,
  setPreparedBranchHoursAPI,
  updatePreparedBranchAPI,
  uploadPreparedBranchLicenseAPI,
} from "../../../utils/api/branchPreparation";
import { serializeHours } from "./useDashboard";

/*
  Branch preparation for a client owner (`restaurant.branch.prepare`): create, edit, complete (working hours, license) and remove the DRAFT
  branches of the selected store directly - no subscription is needed - and refresh the dashboard after each change. Returns null when the
  role does not hold the permission. Nothing here activates a branch.
*/
const tokenOf = () => localStorage.getItem("auth-token");

export default function useBranchPreparation({ storeId, enabled, onChanged }) {
  const refresh = useRef(onChanged);
  refresh.current = onChanged;
  return useMemo(() => {
    if (!enabled || !storeId) return null;
    const then = (work) => async (...args) => {
      const result = await work(...args);
      await refresh.current?.();
      return result;
    };
    return {
      createBranch: then((payload) => createPreparedBranchAPI(tokenOf(), storeId, payload)),
      updateBranch: then((branchId, payload) => updatePreparedBranchAPI(tokenOf(), storeId, branchId, payload)),
      removeBranch: then((branchId) => removePreparedBranchAPI(tokenOf(), storeId, branchId)),
      setHours: then((branchId, hours) => setPreparedBranchHoursAPI(tokenOf(), storeId, branchId, [serializeHours(hours)])),
      uploadLicense: then((branchId, file) => uploadPreparedBranchLicenseAPI(tokenOf(), storeId, branchId, file)),
      removeLicense: then((branchId) => removePreparedBranchLicenseAPI(tokenOf(), storeId, branchId)),
    };
  }, [enabled, storeId]);
}
